import styled from 'styled-components'

export const FormInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
`

export const LogoWrapper = styled.div`
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid ${o => o.theme.color.deprecated.stone};
  max-width: 200px;
  width: 100%;
`
